import type { DeviationFE, DeviationSeverityFE } from 'domain/vehicle';

export const setSeverity = (deviations: DeviationFE[] | undefined): DeviationSeverityFE => {
    if (deviations?.find(deviation => deviation.severity === 'FATAL')) {
        return 'FATAL';
    }

    if (deviations?.find(deviation => deviation.severity === 'ERROR')) {
        return 'ERROR';
    }

    if (deviations?.find(deviation => deviation.severity === 'WARNING')) {
        return 'WARNING';
    }

    return 'UNKNOWN';
};
